// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rGxb","badges":"styles_badges__2vfF_"};